/**
 * Extract cart info from cart fragments
 *
 * @since 1.0.0
 */

import type { RedFoxCartData } from '@/frontend/types/cart';

import type { CartFragments } from '../types';

/**
 * Extract cart info from cart fragments
 *
 * @param cartFragments - Cart fragments data from PHP
 */
export const extractCartInfoFromFragments = (
  cartFragments: Record<string, unknown>
): RedFoxCartData['cart_info'] => {
  const typedFragments = cartFragments as CartFragments;
  const cartTotals = typedFragments?.cart_totals ?? {};
  const cartUrls = typedFragments?.cart_urls ?? {};

  return {
    count: parseInt(String(cartTotals.contents_count ?? 0), 10) || 0,
    cart_url: String(cartUrls.cart_url ?? '/cart'),
    checkout_url: String(cartUrls.checkout_url ?? '/checkout'),
  };
};
